import { useState } from 'react';
import { FileText } from 'lucide-react';
import { ActionButton, EmptyState, Pagination } from '@practium/ui';
import { useGetPlanCharges } from '@practium/features/api';
import { MyPlanSectionCard } from '../MyPlanSectionCard/MyPlanSectionCard';
import { ChargeStatusBadge } from '../ChargeStatusBadge/ChargeStatusBadge';
import { formatCents, formatDate, formatChargeDescription } from '../../utils/formatMyPlan';
import styles from './InvoicesCard.module.css';

const PAGE_SIZE = 5;

export const InvoicesCard = () => {
	const [page, setPage] = useState(1);
	const { data, isLoading } = useGetPlanCharges(page, PAGE_SIZE);
	const charges = data?.docs ?? [];
	const totalPages = data?.totalPages ?? 1;
	const isEmpty = !isLoading && charges.length === 0;

	return (
		<MyPlanSectionCard
			title="Faturas"
			subtitle="Baixe a nota fiscal de qualquer cobrança."
			headerAction={<ActionButton text="Ver Relatório" onClick={() => {}} />}
		>
			<div className={`${styles.body} ${isEmpty ? styles.bodyEmpty : ''}`}>
				{isLoading && charges.length === 0 ? (
					<p className={styles.empty}>Carregando faturas...</p>
				) : isEmpty ? (
					<EmptyState
						icon={<FileText size={28} />}
						title="Nenhuma fatura encontrada"
						description="As cobranças da sua assinatura e dos pacotes de tokens aparecem aqui."
					/>
				) : (
					<>
						<div className={styles.tableWrap}>
							<table className={styles.table}>
								<thead>
									<tr>
										<th>Data</th>
										<th>Descrição</th>
										<th>Valor</th>
										<th>Status</th>
										<th />
									</tr>
								</thead>
								<tbody>
									{charges.map((charge) => (
										<tr key={charge._id}>
											<td>{formatDate(charge.createdAt)}</td>
											<td>{formatChargeDescription(charge.description)}</td>
											<td>{formatCents(charge.amount)}</td>
											<td>
												<ChargeStatusBadge status={charge.chargeStatus} />
											</td>
											<td>
												<button type="button" className={styles.invoice} onClick={() => {}}>
													Nota Fiscal
												</button>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
					</>
				)}
			</div>
		</MyPlanSectionCard>
	);
};
